// eslint-disable-next-line import/prefer-default-export
export const formatTime = (time: string) => new Date(time).toLocaleString();
